// Origin of the Acronis account domain. Must include protocol, no trailing slash.
export const ACCOUNT_ORIGIN = 'https://account.acronis.com';

// Path on the account domain where users complete the 2FA challenge.
// The account UI uses a hash router, so query params live inside the fragment.
export const ACCOUNT_TWO_FA_PATH = '/#/auth/login';
